import { Inject, Injectable } from '@angular/core';
import { CrudService } from '../base/crud/crud.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class SessionService extends CrudService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "session");
    }
}
